import * as Actions from '../actions/Actions';

const initialState = {
    user: undefined,
    permissions: []
};

const authReducers = (state = initialState, action) => {

    switch (action.type) {

        case  Actions.LOGIN:
        case Actions.LOAD_USER:
            return {
                ...state,
                user: action.user
            };
        case Actions.LOGOUT:
            return {
                ...state,
                user: undefined
            };
        case Actions.SET_PERMISSIONS:
            
            return{
                ...state,
                permissions: action.permissions
            }

        default: return state;
    }
};

export default authReducers;